import React from 'react'
import {Column} from 'react-table'
import {Model} from '@/_metronic/helpers'
import {
  IdentityCell,
  ActionsCell,
  DateCell,
  CustomHeader
} from '@/components/table/columns'
import {ActionCellProps} from '@/components/table/core/_types'

import {EndPointCell, BrowserCell, IpCell} from './ActivityCells'
import {IntlShape} from 'react-intl'

const df = {
  year: 'numeric',
  month: 'long',
  day: 'numeric',
  hour: 'numeric',
  minute: 'numeric',
  second: 'numeric'
} as Intl.DateTimeFormatOptions

const getColumns = (intl: IntlShape, isUser?: boolean) : ReadonlyArray<Column<Model>> => [{
  Header: (props) => <CustomHeader tableProps={props} title={intl.formatMessage({id:'CORE.USERS.ACTIVITY.TABLE.COL_USER'})} className='min-w-125px' />,
  id: 'lastname',
  Cell: ({...props}) =>
    <IdentityCell
      email={props.data[props.row.index].user.email}
      displayName={props.data[props.row.index].user.username}
      to={`/p2c/customers/${props.data[props.row.index].user._id}/overview`}
    />
}, {
  Header: (props) => <CustomHeader tableProps={props} title={intl.formatMessage({id:'CORE.USERS.ACTIVITY.TABLE.COL_DATE'})} className='min-w-125px' />,
  id: 'date',
  Cell: ({...props}) => <DateCell date={props.data[props.row.index].date} format={df}/>
}, {
  Header: (props) => <CustomHeader tableProps={props} title='Browser' className='min-w-125px sortable' />,
  id: 'browser',
  Cell: ({...props}) => <BrowserCell ua={props.data[props.row.index].userAgent} />
}, {
  Header: (props) => <CustomHeader tableProps={props} title='Ip' className='min-w-125px sortable' />,
  id: 'clientIp.value',
  Cell: ({...props}) => <IpCell ip={ props.data[props.row.index].clientIp} />
}, {
  Header: (props) => <CustomHeader tableProps={props} title={intl.formatMessage({id:'CORE.USERS.ACTIVITY.TABLE.COL_RESOURCE'})} className='min-w-125px' />,
  id: 'route',
  Cell: ({...props}) => (
    <EndPointCell
      method={props.data[props.row.index].method}
      route={props.data[props.row.index].route}
      response={props.data[props.row.index].response}
    />
  )
}, {
  Header: (props) => (
    <CustomHeader tableProps={props} title={intl.formatMessage({id:'COMPONENT.TABLE.COL.ACTIONS'})} className='text-end min-w-100px' />
  ),
  id: 'actions',
  Cell: ({...props}) => {
    const actions: ActionCellProps[] = [{
      icon: 'exit-right-corner',
      label: intl.formatMessage({id:'CORE.USERS.ACTIVITY.TABLE.COL.ACTION.REQUEST_DETAILS'}),
      openModal: 'details'
    }]

    if (!isUser) {
      actions.push({
        icon: 'badge',
        label: intl.formatMessage({id:'CORE.USERS.ACTIVITY.TABLE.COL.ACTION.USER_VIEW'}),
        navigate:  `/p2c/customers/${props.data[props.row.index].user._id}/overview`
      })
    }

    return (
      <ActionsCell
        itemForUpdate={props.data[props.row.index]}
        actions={actions}
      />
    )
  }
}]

export {getColumns}
